"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCustomId = exports.getVehicleAccessoryCustomId = void 0;
const utils_1 = require("../../utils");
const getVehicleAccessoryCustomId = (order, accessory) => (0, exports.getCustomId)(accessory, order);
exports.getVehicleAccessoryCustomId = getVehicleAccessoryCustomId;
const getCustomId = (accessory, order = null) => {
    return `${(order === null || order === void 0 ? void 0 : order.id) || (0, utils_1.getRandomInt)(1000000, 9999999)}_${(accessory === null || accessory === void 0 ? void 0 : accessory.id) || (0, utils_1.getRandomInt)(1000000, 9999999)}`;
};
exports.getCustomId = getCustomId;
//# sourceMappingURL=vehicle.js.map